import type { ComponentProps, JSX, PropsWithChildren } from 'react';
import { forwardRef } from 'react';

import { Button } from '@change/ds-core-ui';

type Props = Readonly<{
	onClick?: () => void;
}> &
	ComponentProps<typeof Button>;

export const LoadMoreButton = forwardRef<HTMLButtonElement, PropsWithChildren<Props>>(function LoadMoreButton(
	{ children, onClick, ...rest }: PropsWithChildren<Props>,
	ref,
): JSX.Element {
	return (
		<Button variant="secondary" onClick={onClick} ref={ref} {...rest}>
			{children}
		</Button>
	);
});
